"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ParsedDesc_1 = require("./ParsedDesc");

var Parser_1 = require("./Parser");

var FlagSetDesc =
/*#__PURE__*/
function (_ParsedDesc_1$ParsedD) {
  _inherits(FlagSetDesc, _ParsedDesc_1$ParsedD);

  function FlagSetDesc(base, desc, validators) {
    var _this;

    _classCallCheck(this, FlagSetDesc);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FlagSetDesc).call(this, new Parser_1.FlagSetParser(base), desc, validators));
    _this.base = base;
    return _this;
  }

  _createClass(FlagSetDesc, [{
    key: "withDescription",
    value: function withDescription(descr) {
      return new FlagSetDesc(this.base, this.mergeDescs(descr), this.validators);
    }
  }, {
    key: "acceptVisitor",
    value: function acceptVisitor(visitor) {
      return visitor.visitFlagSet(this);
    }
  }]);

  return FlagSetDesc;
}(ParsedDesc_1.ParsedDesc);

exports.FlagSetDesc = FlagSetDesc;